import { useToast } from '@chakra-ui/react'

type TOAST_STATUS = 'info' | 'warning' | 'success' | 'error' | 'loading' | undefined;

export const ERROR_MESSAGE = 'Ocurrió un error. Por favor inténtalo nuevamente.';
export const useNotify = () => {
  const toast = useToast();
  return (message: string, status: TOAST_STATUS = 'info') => toast({
    title: message,
    status: status,
    duration: 4000,
    isClosable: true,
  });
};
